// extracted by mini-css-extract-plugin
export var categoryList = "category-list-module--categoryList--6862b";
export var categoryListTitle = "category-list-module--categoryListTitle--4a0a7";